import React from "react";
import Logo from "../Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div>
      <div
        id="footer"
        className="bg-black font-energetic p-4 sm:pt-10 lg:p-12 border-t-[1px] border-solid border-gray-600"
      >
        <footer className="mx-auto max-w-screen-2xl px-4 md:px-8">
          <div className="mb-16 flex flex-col md:flex-row justify-between md:gap-12 gap-4 lg:gap-8 lg:pt-12">
            <div className="col-span-full lg:col-span-2">
              <div className="mb-4 lg:-mt-2">
                <a
                  className="text-white items-center gap-2 text-xl font-bold md:text-2xl"
                  aria-label="logo"
                  href="/"
                >
                  <Logo />
                  <p className="max-w-[700px]">Broadcasting from Manchester</p>
                </a>
              </div>
              <p className="text-gray-400 max-w-[500px] mb-6 sm:pr-8">
                Live 24/7 from Manchester, <br />
                United Kingdom.
              </p>
            </div>
            <div>
              <div className="text-gray-400 mb-4 font-bold tracking-widest">
                Navigation
              </div>
              <nav className="flex flex-col gap-4">
                <div>
                  <a
                    className="text-gray-400 hover:text-orange-500 active:text-orange-600 transition duration-100"
                    href="/"
                  >
                    Home &copy; copyright 2025
                  </a>
                </div>
                <div>
                  <Link
                    className="text-gray-400 hover:text-orange-500 active:text-orange-600 transition duration-100"
                    to="/privacy"
                  >
                    privacy
                  </Link>
                </div>
              </nav>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
